import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ai-sidebar-chat"
}
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "sidebar-tabs" }
const _hoisted_4 = { class: "sidebar-actions" }
const _hoisted_5 = { class: "sidebar-content" }
const _hoisted_6 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_7 = { class: "empty-state__examples" }
const _hoisted_8 = { class: "input-area" }
const _hoisted_9 = { class: "system-prompt-section" }
const _hoisted_10 = {
  key: 0,
  class: "system-prompt-badge"
}
const _hoisted_11 = { class: "system-prompt-editor" }
const _hoisted_12 = {
  key: 0,
  class: "template-selector"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  class: "mode-toggle",
  role: "group",
  "aria-label": "Chat mode"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "model-thinking-row" }
const _hoisted_20 = { class: "model-selector" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["label"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "thinking-toggle"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "thinking-text" }
const _hoisted_27 = ["href"]
const _hoisted_28 = {
  key: 1,
  class: "captured-context"
}
const _hoisted_29 = { class: "captured-context__header" }
const _hoisted_30 = { class: "captured-context__label" }
const _hoisted_31 = { class: "captured-context__text" }
const _hoisted_32 = {
  key: 2,
  class: "context-indicator"
}
const _hoisted_33 = {
  key: 3,
  class: "pending-images"
}
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = {
  key: 0,
  class: "pending-image__status"
}
const _hoisted_36 = {
  key: 1,
  class: "pending-image__status pending-image__status--error"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "input-row" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["placeholder", "disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "sidebar-content sidebar-content--preview" }
const _hoisted_43 = { class: "thread-modal" }
const _hoisted_44 = { class: "thread-modal__toolbar" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "thread-modal__body" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "thread-item__main" }
const _hoisted_50 = { class: "thread-item__title" }
const _hoisted_51 = { class: "thread-item__time" }
const _hoisted_52 = ["disabled", "onClick"]
const _hoisted_53 = {
  key: 0,
  class: "thread-modal__empty"
}
const _hoisted_54 = {
  key: 1,
  class: "thread-modal__loading"
}
const _hoisted_55 = { class: "usage-modal" }
const _hoisted_56 = { class: "usage-modal__body" }
const _hoisted_57 = { class: "usage-model-box" }
const _hoisted_58 = { class: "usage-model-box__name" }
const _hoisted_59 = { class: "usage-model-box__id" }
const _hoisted_60 = {
  key: 0,
  class: "usage-state"
}
const _hoisted_61 = {
  key: 1,
  class: "usage-state usage-state--error"
}
const _hoisted_62 = { class: "usage-progress" }
const _hoisted_63 = { class: "usage-percent" }
const _hoisted_64 = { class: "usage-grid" }
const _hoisted_65 = { class: "usage-item" }
const _hoisted_66 = { class: "usage-item__value" }
const _hoisted_67 = { class: "usage-item" }
const _hoisted_68 = { class: "usage-item__value" }
const _hoisted_69 = { class: "usage-item" }
const _hoisted_70 = { class: "usage-item__value" }
const _hoisted_71 = { class: "usage-item" }
const _hoisted_72 = { class: "usage-item__value" }
const _hoisted_73 = { class: "usage-item" }
const _hoisted_74 = { class: "usage-item__value" }
const _hoisted_75 = { class: "usage-item" }
const _hoisted_76 = { class: "usage-item__value" }
const _hoisted_77 = {
  key: 0,
  class: "usage-alert"
}

import { ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import ChatMessageComponent from './ChatMessageComponent.vue'
import {
  ChatMessage,
  ChatContext,
  buildChatContext,
  buildContextLabel,
  parseAiResponse,
  generateMessageId
} from '../lib/monaco/ai-sidebar-chat'
import { InlineDiffSession } from '../lib/monaco/inline-diff'
import api from '../../api/v2/api'
import { qEditorState } from '../stores'
import ImageApi from '../api/ImageAPI'
import { resizeImageFile, createPreviewDataUrl } from '../lib/image-resize'
import { AiUsageSummary } from '../../api/v2/api/admin/ai_usage'

interface EditorModel {
  id: string
  provider: string
  name: string
  supports_thinking: boolean
  thinking_required: boolean
  supports_vision: boolean
}

interface ModelGroup {
  provider: string
  models: EditorModel[]
}

interface AiChatThreadSummary {
  id: number
  title: string | null
  featureType: string
  examId: number | null
  createdAt: string
  updatedAt: string
}

interface AiChatThreadMessage {
  id: number
  role: 'user' | 'assistant' | 'system'
  content: string
  reasoningContent?: string
  model?: string
  stoppedByUser?: boolean
  attachments?: Array<{ url: string; filename: string }>
  createdAt: string
}

const STORAGE_KEY_SYSTEM_PROMPT = 'ai_sidebar_system_prompt'
const STORAGE_KEY_THINKING = 'ai_sidebar_thinking_enabled'
const STORAGE_KEY_MODEL = 'ai_sidebar_selected_model'
const STORAGE_KEY_MODE = 'ai_sidebar_chat_mode'

// Template refs

export default /*@__PURE__*/_defineComponent({
  __name: 'AiSidebarChatComponent',
  props: {
    visible: { type: Boolean, default: false },
    editor: { default: null },
    examId: {},
    onContentChange: { type: [Function, null], default: null }
  },
  emits: ["close"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

const messagesArea = ref<HTMLElement | null>(null)
const inputField = ref<HTMLTextAreaElement | null>(null)
const imageInput = ref<HTMLInputElement | null>(null)

const activeTab = ref<string>('chat')
const messages = ref<ChatMessage[]>([])
const inputText = ref<string>('')
const isStreaming = ref<boolean>(false)
const currentContext = ref<ChatContext | null>(null)
const promptForQuestions = ref<any[]>([])
const selectedPromptId = ref<number | null>(null)
const selectedModel = ref<string>('gpt-5.1')
const capturedContext = ref<ChatContext | null>(null)
const systemPromptExpanded = ref<boolean>(false)
const customSystemPrompt = ref<string>('')
const thinkingEnabled = ref<boolean>(false)
// Cursor-like mode: 'agent' = AI may edit the editor (apply diff), 'ask' = chat only (never edits)
const chatMode = ref<'agent' | 'ask'>('agent')

const pendingImages = ref<Array<{
  url: string
  filename: string
  previewDataUrl: string
  uploading: boolean
  error?: string
}>>([])
let waitStartedAt: number | null = null
let waitTimerId: number | null = null
let currentStreamingMsgId: string | null = null
let streamTimeoutId: number | null = null

// School ID for config link
const schoolId = ref<number | null>(null)

// Available models (loaded from server)
const editorModels = ref<EditorModel[]>([])
const threads = ref<AiChatThreadSummary[]>([])
const selectedThreadId = ref<number | null>(null)
const threadModalVisible = ref<boolean>(false)
const usageModalVisible = ref<boolean>(false)
const loadingThreads = ref<boolean>(false)
const loadingThreadDetail = ref<boolean>(false)
const loadingUsage = ref<boolean>(false)
const usageError = ref<string>('')
const usageData = ref<AiUsageSummary | null>(null)

// ActionCable callback reference
let chatCallbackActive: boolean = false

// Active inline diff review session (Cursor-style accept/reject per question)
let activeDiffSession: InlineDiffSession | null = null

const groupedModels = computed<ModelGroup[]>(() => {
  const groups: { [key: string]: EditorModel[] } = {}
  for (const model of editorModels.value) {
    const provider = model.provider.charAt(0).toUpperCase() + model.provider.slice(1)
    if (!groups[provider]) groups[provider] = []
    groups[provider].push(model)
  }
  return Object.keys(groups).sort().map(provider => ({
    provider,
    models: groups[provider]
  }))
})

const selectedModelSupportsThinking = computed<boolean>(() => {
  const model = editorModels.value.find(m => m.id === selectedModel.value)
  return model?.supports_thinking || false
})

const selectedModelRequiresThinking = computed<boolean>(() => {
  const model = editorModels.value.find(m => m.id === selectedModel.value)
  return model?.thinking_required || false
})

const selectedModelName = computed<string>(() => {
  const model = editorModels.value.find(m => m.id === selectedModel.value)
  return model?.name || selectedModel.value
})

const usageProgressWidth = computed<string>(() => {
  const value = usageData.value?.usagePercentage || 0
  const normalized = Math.max(0, Math.min(100, value))
  return `${normalized}%`
})

const currentContextLabel = computed<string>(() => {
  if (!props.editor) return ''
  const ctx = buildChatContext(props.editor)
  return buildContextLabel(ctx)
})

const truncatedCapturedText = computed<string>(() => {
  if (!capturedContext.value?.selectedText) return ''
  const text = capturedContext.value.selectedText
  const maxLen = 150
  if (text.length <= maxLen) return text
  return text.substring(0, maxLen) + '...'
})

const canSend = computed<boolean>(() => {
  return (inputText.value.trim().length > 0 || pendingImages.value.length > 0) &&
    !isStreaming.value &&
    !pendingImages.value.some(img => img.uploading)
})

const inputPlaceholder = computed<string>(() => {
  if (isStreaming.value) return 'AI is generating...'
  return chatMode.value === 'ask'
    ? 'Ask anything... (chat only, no edits)'
    : 'Tell AI to create or edit... (applies to editor)'
})

onMounted(() => {
    // Load prompts from data attribute
    try {
      const editorData = document.getElementById('question_editor_data')
      if (editorData?.dataset.prompts) {
        promptForQuestions.value = JSON.parse(editorData.dataset.prompts)
          .filter((prompt: any) => prompt.category === 'auto_question')
      }

      // Load school ID for config link
      if (editorData?.dataset.school) {
        try {
          const schoolData = JSON.parse(editorData.dataset.school)
          schoolId.value = schoolData.id || null
        } catch (e) { /* ignore */ }
      }

      // Load available models from server
      if (editorData?.dataset.editorModels) {
        const models = JSON.parse(editorData.dataset.editorModels)
        if (models && models.length > 0) {
          editorModels.value = models
          // Select first model if current selection is not in the list
          if (!editorModels.value.find(m => m.id === selectedModel.value)) {
            selectedModel.value = editorModels.value[0].id
          }
        }
      }
    } catch (e) {
      console.warn('Failed to parse editor data', e)
    }

    // Fallback: if no models loaded from server, use defaults
    if (editorModels.value.length === 0) {
      editorModels.value = [
        { id: 'gpt-5.1', provider: 'openai', name: 'GPT-5.1 (latest)', supports_thinking: true, thinking_required: false, supports_vision: true },
        { id: 'gpt-4o-mini', provider: 'openai', name: 'GPT-4o Mini', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'claude-3-5-haiku-latest', provider: 'anthropic', name: 'Claude 3.5 Haiku', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'claude-3-5-sonnet-latest', provider: 'anthropic', name: 'Claude 3.5 Sonnet', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'claude-3-7-sonnet-latest', provider: 'anthropic', name: 'Claude 3.7 Sonnet', supports_thinking: true, thinking_required: false, supports_vision: true },
        { id: 'claude-4-sonnet', provider: 'anthropic', name: 'Claude 4 Sonnet', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'claude-4-5-haiku', provider: 'anthropic', name: 'Claude 4.5 Haiku', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'claude-4-5-opus', provider: 'anthropic', name: 'Claude 4.5 Opus', supports_thinking: true, thinking_required: false, supports_vision: true },
        { id: 'claude-4-5-sonnet', provider: 'anthropic', name: 'Claude 4.5 Sonnet', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'gemini-2.0-flash', provider: 'gemini', name: 'Gemini 2.0 Flash', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'gemini-2.0-pro', provider: 'gemini', name: 'Gemini 2.0 Pro', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'gemini-2.5-flash', provider: 'gemini', name: 'Gemini 2.5 Flash', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'gemini-3-flash-preview', provider: 'gemini', name: 'Gemini 3 Flash', supports_thinking: false, thinking_required: false, supports_vision: true },
        { id: 'gemini-3-pro-preview', provider: 'gemini', name: 'Gemini 3 Pro', supports_thinking: true, thinking_required: false, supports_vision: true },
        { id: 'deepseek-chat', provider: 'deepseek', name: 'DeepSeek Chat', supports_thinking: false, thinking_required: false, supports_vision: false },
        { id: 'deepseek-reasoner', provider: 'deepseek', name: 'DeepSeek Reasoner', supports_thinking: true, thinking_required: true, supports_vision: false },
        { id: 'kimi-k2', provider: 'kimi', name: 'Kimi K2', supports_thinking: false, thinking_required: false, supports_vision: false },
      ]
    }

    // Load saved settings from localStorage
    try {
      const saved = localStorage.getItem(STORAGE_KEY_SYSTEM_PROMPT)
      if (saved) {
        customSystemPrompt.value = saved
      }
      const thinkingSaved = localStorage.getItem(STORAGE_KEY_THINKING)
      if (thinkingSaved === 'true') {
        thinkingEnabled.value = true
      }
      const modeSaved = localStorage.getItem(STORAGE_KEY_MODE)
      if (modeSaved === 'ask' || modeSaved === 'agent') {
        chatMode.value = modeSaved
      }
      // Restore selected model (only if it exists in available models)
      const savedModel = localStorage.getItem(STORAGE_KEY_MODEL)
      if (savedModel && editorModels.value.find(m => m.id === savedModel)) {
        selectedModel.value = savedModel
      }
    } catch (e) {
      // localStorage might be unavailable
    }

    // Register global keyboard shortcut: Cmd+Enter to apply latest changes
    document.addEventListener('keydown', onGlobalKeydown)

    startNewThreadDraft()
    loadThreads()

    nextTick(() => {
      focusInput()
    })
  })

  watch(selectedModel, (val: string) => {
    // Auto-enable thinking for models that require it
    if (selectedModelRequiresThinking.value) {
      thinkingEnabled.value = true
    }
    // Persist selected model
    try {
      localStorage.setItem(STORAGE_KEY_MODEL, val)
    } catch (e) { /* ignore */ }
  })

  watch(customSystemPrompt, (val: string) => {
    try {
      if (val) {
        localStorage.setItem(STORAGE_KEY_SYSTEM_PROMPT, val)
      } else {
        localStorage.removeItem(STORAGE_KEY_SYSTEM_PROMPT)
      }
    } catch (e) {
      // localStorage might be unavailable
    }
  })

  watch(thinkingEnabled, (val: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY_THINKING, val ? 'true' : 'false')
    } catch (e) {
      // localStorage might be unavailable
    }
  })

  watch(chatMode, (val: string) => {
    try {
      localStorage.setItem(STORAGE_KEY_MODE, val)
    } catch (e) {
      // localStorage might be unavailable
    }
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onGlobalKeydown)
    stopWaitTimer()
    if (streamTimeoutId !== null) {
      window.clearTimeout(streamTimeoutId)
      streamTimeoutId = null
    }
    if (activeDiffSession) {
      activeDiffSession.dispose()
      activeDiffSession = null
    }
  })

  /**
   * Global keyboard shortcuts:
   * - Cmd+Enter: Apply the latest AI changes
   * - Cmd+Shift+P: Toggle Chat/Preview tabs
   */
  const onGlobalKeydown = (e: KeyboardEvent) => {
    if (e.isComposing) return

    // Cmd+Enter or Ctrl+Enter: Apply latest pending changes
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      if (!props.visible) return
      const latestPending = getLatestPendingMessage()
      if (latestPending) {
        e.preventDefault()
        onApplyChanges(latestPending)
      }
    }

    // Cmd+Shift+P or Ctrl+Shift+P: Toggle Chat/Preview
    if ((e.metaKey || e.ctrlKey) && e.shiftKey && (e.key === 'p' || e.key === 'P')) {
      if (!props.visible) return
      e.preventDefault()
      e.stopPropagation()
      activeTab.value = activeTab.value === 'chat' ? 'preview' : 'chat'
    }
  }

  watch(() => props.visible, (val: boolean) => {
    if (val) {
      loadThreads()
      nextTick(() => {
        focusInput()
      })
    }
  })

  watch(() => props.examId, (val: number, oldVal: number) => {
    if (!val || val === oldVal) return
    startNewThreadDraft()
    loadThreads()
  })

  const focusInput = () => {
    const input = inputField.value
    if (input) input.focus()
  }

  const openThreadManager = () => {
    usageModalVisible.value = false
    threadModalVisible.value = true
    loadThreads()
  }

  const closeThreadManager = () => {
    threadModalVisible.value = false
  }

  const openUsageModal = () => {
    threadModalVisible.value = false
    usageModalVisible.value = true
    loadUsage()
  }

  const closeUsageModal = () => {
    usageModalVisible.value = false
  }

  const startNewThreadDraft = () => {
    selectedThreadId.value = null
    messages.value = []
  }

  const formatThreadLabel = (thread: AiChatThreadSummary): string => {
    const title = (thread.title || '').trim()
    if (title.length > 0) return title
    const date = new Date(thread.updatedAt || thread.createdAt)
    return `Thread ${date.toLocaleString('ja-JP', { month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}`
  }

  const formatThreadTime = (thread: AiChatThreadSummary): string => {
    const date = new Date(thread.updatedAt || thread.createdAt)
    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  const loadThreads = async () => {
    if (loadingThreads.value) return
    loadingThreads.value = true
    try {
      const rows = await api.admin.aiChatThread.index({
        examId: props.examId,
        featureType: 'qeditor'
      })
      threads.value = [...rows].sort((a: AiChatThreadSummary, b: AiChatThreadSummary) => {
        return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
      })
    } catch (error) {
      console.error('Failed to load AI chat threads:', error)
    } finally {
      loadingThreads.value = false
    }
  }

  const loadUsage = async () => {
    if (loadingUsage.value) return
    loadingUsage.value = true
    usageError.value = ''

    try {
      usageData.value = await api.admin.aiUsage.show({ examId: props.examId })
    } catch (error) {
      console.error('Failed to load AI usage:', error)
      usageError.value = 'Failed to load usage.'
    } finally {
      loadingUsage.value = false
    }
  }

  const createNewThread = async () => {
    if (isStreaming.value) return
    startNewThreadDraft()
    threadModalVisible.value = false
    nextTick(() => focusInput())
  }

  const formatNumber = (value: number | null | undefined): string => {
    return Number(value || 0).toLocaleString('en-US')
  }

  const openThread = async (threadId: number) => {
    if (!threadId || loadingThreadDetail.value || isStreaming.value) return
    if (selectedThreadId.value === threadId && messages.value.length > 0) return

    loadingThreadDetail.value = true
    try {
      const detail = await api.admin.aiChatThread.show(threadId)
      selectedThreadId.value = threadId
      const currentContext = props.editor ? buildChatContext(props.editor) : undefined
      messages.value = (detail.messages || [])
        .filter((msg: AiChatThreadMessage) => msg.role === 'user' || msg.role === 'assistant')
        .map((msg: AiChatThreadMessage) => ({
          id: `thread-${msg.id}`,
          threadMessageId: msg.id,
          role: msg.role as 'user' | 'assistant',
          content: msg.content || '',
          reasoningContent: msg.reasoningContent,
          stoppedByUser: !!msg.stoppedByUser,
          model: msg.model,
          images: Array.isArray(msg.attachments) && msg.attachments.length > 0
            ? msg.attachments
                .filter((img: any) => img && img.url)
                .map((img: any) => ({
                  url: img.url,
                  filename: img.filename || 'image.png'
                }))
            : undefined,
          context: msg.role === 'assistant' && currentContext ? { ...currentContext } : undefined,
          timestamp: new Date(msg.createdAt).getTime()
        }))
      scrollToBottom()
      threadModalVisible.value = false
    } catch (error) {
      console.error('Failed to load thread:', error)
      alert('Failed to load selected thread.')
    } finally {
      loadingThreadDetail.value = false
    }
  }

  const renameCurrentThread = async () => {
    if (!selectedThreadId.value || isStreaming.value) return
    const current = threads.value.find(t => t.id === selectedThreadId.value)
    const currentTitle = current?.title || ''
    const nextTitle = window.prompt('Thread name', currentTitle)
    if (nextTitle === null) return

    try {
      const updated = await api.admin.aiChatThread.update(selectedThreadId.value, { title: nextTitle.trim() })
      const idx = threads.value.findIndex(t => t.id === updated.id)
      if (idx >= 0) threads.value[idx] = updated
    } catch (error) {
      console.error('Failed to rename thread:', error)
      alert('Failed to rename thread.')
    }
  }

  const deleteCurrentThread = async () => {
    if (!selectedThreadId.value) return
    await deleteThread(selectedThreadId.value)
  }

  const deleteThread = async (threadId: number) => {
    if (!threadId || isStreaming.value || loadingThreadDetail.value) return
    const target = threads.value.find(t => t.id === threadId)
    const label = target ? formatThreadLabel(target) : `Thread #${threadId}`
    if (!window.confirm(`Delete "${label}"?`)) return

    try {
      await api.admin.aiChatThread.delete(threadId)
      threads.value = threads.value.filter(t => t.id !== threadId)
      if (selectedThreadId.value === threadId) {
        startNewThreadDraft()
      }
    } catch (error) {
      console.error('Failed to delete thread:', error)
      alert('Failed to delete thread.')
    }
  }

  /**
   * Capture the current editor selection/cursor into capturedContext.
   * Called by parent when Cmd+Shift+L is pressed.
   */
  const captureEditorContext = () => {
    if (!props.editor) return
    const ctx = buildChatContext(props.editor)
    // Only capture if there's meaningful selection or cursor position
    if (ctx.selectedText || ctx.cursorLine > 0) {
      capturedContext.value = { ...ctx }
    }
  }

  const clearCapturedContext = () => {
    capturedContext.value = null
  }

  const insertExample = (text: string) => {
    inputText.value = text
    focusInput()
  }

  const onInputKeydown = (e: KeyboardEvent) => {
    // Skip if IME is composing (e.g. Japanese input conversion)
    if (e.isComposing) return
    if (e.key === 'Enter' && !e.shiftKey && !(e.metaKey || e.ctrlKey)) {
      e.preventDefault()
      sendMessage()
    }
    // Escape: Focus back to editor
    if (e.key === 'Escape') {
      e.preventDefault()
      focusEditor()
    }
  }

  const onPaste = (e: ClipboardEvent) => {
    // Stop propagation so Monaco editor doesn't capture the paste event
    e.stopPropagation()

    const items = e.clipboardData?.items
    if (!items) return

    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      if (item.type.startsWith('image/')) {
        e.preventDefault()
        const file = item.getAsFile()
        if (file) processImageFile(file)
        return
      }
    }
  }

  const triggerImageUpload = () => {
    const input = imageInput.value
    if (input) input.click()
  }

  const onImageFileSelected = (e: Event) => {
    const input = e.target as HTMLInputElement
    const files = input.files
    if (!files) return

    for (let i = 0; i < files.length; i++) {
      processImageFile(files[i])
    }
    // Reset input so same file can be selected again
    input.value = ''
  }

  const removePendingImage = (index: number) => {
    pendingImages.value.splice(index, 1)
  }

  const processImageFile = (file: File) => {
    if (!file.type.startsWith('image/')) return
    // Limit to 5 images
    if (pendingImages.value.length >= 5) return
    // Limit file size to 10MB
    if (file.size > 10 * 1024 * 1024) {
      alert('Image too large. Max 10MB.')
      return
    }

    const pendingIndex = pendingImages.value.push({
      url: '',
      filename: file.name || 'pasted_image.png',
      previewDataUrl: '',
      uploading: true
    }) - 1

    ;(async () => {
      try {
        const resizedFile = await resizeImageFile(file)
        const previewDataUrl = await createPreviewDataUrl(resizedFile)

        pendingImages.value[pendingIndex] = {
          ...pendingImages.value[pendingIndex],
          previewDataUrl
        }

        const exam = qEditorState.exam as any
        const uploadedUrl = await ImageApi.upload(exam, resizedFile)

        pendingImages.value[pendingIndex] = {
          url: uploadedUrl,
          filename: resizedFile.name || file.name || 'pasted_image.png',
          previewDataUrl,
          uploading: false
        }
      } catch (error: any) {
        pendingImages.value[pendingIndex] = {
          ...pendingImages.value[pendingIndex],
          uploading: false,
          error: error?.message || 'Upload failed'
        }
      }
    })()
  }

  const autoResizeInput = () => {
    const input = inputField.value
    if (input) {
      input.style.height = 'auto'
      input.style.height = Math.min(input.scrollHeight, 100) + 'px'
    }
  }

  const ensureThreadForSend = async (): Promise<number | null> => {
    if (selectedThreadId.value) return selectedThreadId.value

    try {
      const created = await api.admin.aiChatThread.create({
        examId: props.examId,
        featureType: 'qeditor'
      })
      selectedThreadId.value = created.id
      threads.value = [created, ...threads.value.filter(t => t.id !== created.id)]
      return created.id
    } catch (error) {
      console.error('Failed to create thread before send:', error)
      alert('Failed to start a new thread.')
      return null
    }
  }

  const sendMessage = async () => {
    if (!canSend.value || !props.editor) return
    const threadId = await ensureThreadForSend()
    if (!threadId) return

    const prompt = inputText.value.trim()
    inputText.value = ''

    // Capture pending images before clearing
    const messageImages = pendingImages.value
      .filter(img => !img.uploading && !img.error && img.url)
      .map(img => ({
        url: img.url,
        filename: img.filename,
        previewDataUrl: img.previewDataUrl
      }))
    pendingImages.value = []

    // Use captured context if available (from Cmd+Shift+L), otherwise get live context
    const context = capturedContext.value || buildChatContext(props.editor)
    currentContext.value = context
    // Clear captured context after using it
    capturedContext.value = null

    // Add user message
    const userMsg: ChatMessage = {
      id: generateMessageId(),
      role: 'user',
      content: prompt || '(image)',
      context: { ...context },
      timestamp: Date.now(),
      images: messageImages.length > 0 ? messageImages : undefined
    }
    messages.value.push(userMsg)

    // Add placeholder AI message for streaming
    const aiMsg: ChatMessage = {
      id: generateMessageId(),
      role: 'assistant',
      content: '',
      context: { ...context },
      streaming: true,
      timestamp: Date.now()
    }
    messages.value.push(aiMsg)

    isStreaming.value = true
    currentStreamingMsgId = aiMsg.id
    startWaitTimer()
    scrollToBottom()

    // Set up ActionCable to receive streamed response
    setupStreamingCallback(aiMsg)

    // Build conversation history for API
    const conversationMessages = messages.value
      .filter(m => m.id !== aiMsg.id) // exclude the placeholder AI message
      .map(m => ({
        role: m.role,
        content: m.content
      }))

    // Call API
    try {
      const result = await api.admin.aiChat.send(props.examId, {
        messages: conversationMessages,
        context: {
          body: context.body,
          selectedText: context.selectedText,
          cursorLine: context.cursorLine,
          isEmptyLine: context.isEmptyLine,
          selectionStartLine: context.selectionStartLine,
          selectionEndLine: context.selectionEndLine
        },
        promptId: selectedPromptId.value || undefined,
        threadId,
        model: selectedModel.value,
        systemPrompt: customSystemPrompt.value || undefined,
        images: messageImages.length > 0 ? messageImages : undefined,
        thinkingEnabled: thinkingEnabled.value && selectedModelSupportsThinking.value,
        mode: chatMode.value
      })

      if (!result.success) {
        qEditorState.setExamGenerationChanelCallback(() => {})
        chatCallbackActive = false
        if (streamTimeoutId !== null) {
          window.clearTimeout(streamTimeoutId)
          streamTimeoutId = null
        }
        currentStreamingMsgId = null
        stopWaitTimer(aiMsg.id)
        const msgIndex = messages.value.findIndex(m => m.id === aiMsg.id)
        if (msgIndex >= 0) {
          messages.value[msgIndex] = {
            ...messages.value[msgIndex],
            content: result.error || 'Monthly AI token limit reached. Please contact admin.',
            streaming: false
          }
        }
        isStreaming.value = false
        scrollToBottom()
        if (usageModalVisible.value) {
          loadUsage()
        }
      }
    } catch (error) {
      console.error('AI Chat send error:', error)
      qEditorState.setExamGenerationChanelCallback(() => {})
      chatCallbackActive = false
      if (streamTimeoutId !== null) {
        window.clearTimeout(streamTimeoutId)
        streamTimeoutId = null
      }
      currentStreamingMsgId = null
      stopWaitTimer(aiMsg.id)
      const msgIndex = messages.value.findIndex(m => m.id === aiMsg.id)
      if (msgIndex >= 0) {
        messages.value[msgIndex] = {
          ...messages.value[msgIndex],
          content: 'Failed to send message. Please try again.',
          streaming: false
        }
      }
      isStreaming.value = false
      scrollToBottom()
      if (usageModalVisible.value) {
        loadUsage()
      }
    }
  }

  const stopStreaming = () => {
    if (!isStreaming.value) return
    qEditorState.setStopExamGenerationChanel()

    if (currentStreamingMsgId) {
      const msgIndex = messages.value.findIndex(m => m.id === currentStreamingMsgId)
      if (msgIndex >= 0) {
        messages.value[msgIndex] = {
          ...messages.value[msgIndex],
          streaming: false,
          stoppedByUser: true
        }
      }
    }

    chatCallbackActive = false
    isStreaming.value = false
    stopWaitTimer(currentStreamingMsgId || undefined)
    currentStreamingMsgId = null
    qEditorState.setExamGenerationChanelCallback(() => {})
    window.setTimeout(() => loadThreads(), 300)
    if (usageModalVisible.value) {
      loadUsage()
    }
  }

  const setupStreamingCallback = (aiMsg: ChatMessage) => {
    chatCallbackActive = true
    if (streamTimeoutId !== null) {
      window.clearTimeout(streamTimeoutId)
      streamTimeoutId = null
    }

    // Subscribe to ActionCable channel
    qEditorState.setFollowExamGenerationChanel()

    // Set callback for incoming chunks
    qEditorState.setExamGenerationChanelCallback(
      (content: string, _chunk: string, finished: boolean, extraData?: any) => {
        if (!chatCallbackActive) return

        if (waitStartedAt !== null && (content.length > 0 || !!extraData?.reasoning_content || finished)) {
          stopWaitTimer(aiMsg.id)
        }

        // Update the AI message content
        const msgIndex = messages.value.findIndex(m => m.id === aiMsg.id)
        if (msgIndex >= 0) {
          const updatedMsg: any = {
            ...messages.value[msgIndex],
            content: content,
            streaming: !finished
          }

          // Track reasoning content if available
          if (extraData?.reasoning_content) {
            updatedMsg.reasoningContent = extraData.reasoning_content
          }
          if (extraData?.stopped_by_user) {
            updatedMsg.stoppedByUser = true
          }

          messages.value[msgIndex] = updatedMsg
        }

        if (finished) {
          chatCallbackActive = false
          isStreaming.value = false
          currentStreamingMsgId = null
          if (streamTimeoutId !== null) {
            window.clearTimeout(streamTimeoutId)
            streamTimeoutId = null
          }
          loadThreads()
          if (usageModalVisible.value) {
            loadUsage()
          }
          // Restore default no-op callback
          qEditorState.setExamGenerationChanelCallback(() => {})

          // Auto-launch inline diff review (Agent mode only): AI changes go straight
          // into the editor as a reviewable diff (accept = keep, reject = remove).
          // onApplyChanges refocuses the chat input when there is nothing to review.
          if (chatMode.value === 'agent') {
            const finalIndex = messages.value.findIndex(m => m.id === aiMsg.id)
            if (finalIndex >= 0) {
              const finalMsg = messages.value[finalIndex]
              nextTick(() => onApplyChanges(finalMsg))
            }
          } else {
            // Ask mode: chat only, keep focus in the input to continue the conversation.
            nextTick(() => focusInput())
          }
        }

        scrollToBottom()
      }
    )

    // Timeout safety
    streamTimeoutId = window.setTimeout(() => {
      streamTimeoutId = null
      if (chatCallbackActive) {
        chatCallbackActive = false
        isStreaming.value = false
        currentStreamingMsgId = null
        stopWaitTimer(aiMsg.id)
        const msgIndex = messages.value.findIndex(m => m.id === aiMsg.id)
        if (msgIndex >= 0) {
          const msg = messages.value[msgIndex]
          messages.value[msgIndex] = {
            ...msg,
            streaming: false,
            content: msg.content || '[AI generation timed out]'
          }
        }
        qEditorState.setExamGenerationChanelCallback(() => {})
      }
    }, 90000) // 90s timeout
  }

  const startWaitTimer = () => {
    stopWaitTimer()
    waitStartedAt = Date.now()
    // Update the streaming message's firstResponseMs every 100ms for live display
    waitTimerId = window.setInterval(() => {
      if (waitStartedAt === null || !currentStreamingMsgId) return
      const elapsed = Date.now() - waitStartedAt
      const msgIndex = messages.value.findIndex(m => m.id === currentStreamingMsgId)
      if (msgIndex >= 0) {
        const msg = messages.value[msgIndex]
        messages.value[msgIndex] = { ...msg, firstResponseMs: elapsed }
      }
    }, 100)
  }

  const stopWaitTimer = (msgId?: string) => {
    if (waitTimerId !== null) {
      window.clearInterval(waitTimerId)
      waitTimerId = null
    }
    if (waitStartedAt !== null && msgId) {
      const elapsed = Date.now() - waitStartedAt
      const msgIndex = messages.value.findIndex(m => m.id === msgId)
      if (msgIndex >= 0) {
        const msg = messages.value[msgIndex]
        messages.value[msgIndex] = { ...msg, firstResponseMs: elapsed }
      }
    }
    waitStartedAt = null
  }

  const onApplyChanges = (message: ChatMessage) => {
    if (!props.editor) return

    const context = message.context || buildChatContext(props.editor)
    const cursorLine = context.cursorLine || 0
    const { changes } = parseAiResponse(message.content, cursorLine)
    // No editable changes (pure chat answer): keep the user in the chat input.
    if (changes.length === 0) { nextTick(() => focusInput()); return }

    // Tear down any previous review session before starting a new one
    if (activeDiffSession) {
      activeDiffSession.dispose()
      activeDiffSession = null
    }

    // Open a Cursor-style inline diff: user accepts/rejects each question (hunk)
    const session = new InlineDiffSession(props.editor, (anyAccepted: boolean) => {
      activeDiffSession = null
      const msgIndex = messages.value.findIndex(m => m.id === message.id)
      if (msgIndex >= 0) {
        messages.value[msgIndex] = {
          ...messages.value[msgIndex],
          appliedChanges: anyAccepted,
          rejectedChanges: !anyAccepted
        }
      }
      if (anyAccepted && props.onContentChange) {
        const model = props.editor.getModel()
        if (model) props.onContentChange(model.getValue())
      }
      // After resolving the diff, return focus to the chat input so the user can keep chatting.
      nextTick(() => focusInput())
    })

    if (session.start(changes)) {
      activeDiffSession = session
      nextTick(() => focusEditor())
    }
  }

  const onRejectChanges = (message: ChatMessage) => {
    // Mark message as rejected
    const msgIndex = messages.value.findIndex(m => m.id === message.id)
    if (msgIndex >= 0) {
      messages.value[msgIndex] = {
        ...messages.value[msgIndex],
        rejectedChanges: true
      }
    }
  }

  const scrollToBottom = () => {
    nextTick(() => {
      const area = messagesArea.value
      if (area) {
        area.scrollTop = area.scrollHeight
      }
    })
  }

  // Public method: open chat with pre-filled prompt (called from editor keybinding)
  const openWithPrompt = (prompt?: string) => {
    activeTab.value = 'chat'
    if (prompt) {
      inputText.value = prompt
    }
    nextTick(() => focusInput())
  }

  /** Focus back to the Monaco editor */
  const focusEditor = () => {
    if (props.editor && typeof props.editor.focus === 'function') {
      props.editor.focus()
    }
  }

  /** Get the latest AI message that has pending (unapplied) changes */
  const getLatestPendingMessage = (): ChatMessage | null => {
    for (let i = messages.value.length - 1; i >= 0; i--) {
      const msg = messages.value[i]
      if (msg.role === 'assistant' && !msg.streaming && !msg.appliedChanges && !msg.rejectedChanges) {
        const { changes } = parseAiResponse(msg.content)
        if (changes.length > 0) return msg
      }
    }
    return null
  }

  __expose({ captureEditorContext, openWithPrompt, inputField })

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Header with tabs "),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: _normalizeClass(['tab-btn', { active: activeTab.value === 'chat' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'chat'))
            }, " 🤖 Chat ", 2 /* CLASS */),
            _createElementVNode("button", {
              class: _normalizeClass(['tab-btn', { active: activeTab.value === 'preview' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'preview'))
            }, " 👁 Preview ", 2 /* CLASS */)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "usage-manager-btn",
              onClick: openUsageModal,
              title: "AI usage"
            }, "📊"),
            _createElementVNode("button", {
              class: "thread-manager-btn",
              onClick: openThreadManager,
              title: "Manage threads"
            }, "🧵"),
            _createElementVNode("button", {
              class: "sidebar-close",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
              title: "Close"
            }, "✕")
          ])
        ]),
        _createCommentVNode(" Chat Tab "),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createCommentVNode(" Messages Area "),
          _createElementVNode("div", {
            class: "messages-area",
            ref_key: "messagesArea",
            ref: messagesArea
          }, [
            (messages.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "empty-state__icon" }, "💬", -1 /* CACHED */)),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "empty-state__title" }, "AI Editor Assistant", -1 /* CACHED */)),
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "empty-state__desc" }, [
                    _createTextVNode(" Select text and ask AI to modify it, or place cursor on an empty line to generate content. "),
                    _createElementVNode("br"),
                    _createElementVNode("br"),
                    _createElementVNode("strong", null, "💡 Smart mode:"),
                    _createTextVNode(" AI automatically decides whether to chat or edit code based on your message. ")
                  ], -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "example",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (insertExample('Add one more option to this question')))
                    }, " \"Add one more option to this question\" "),
                    _createElementVNode("div", {
                      class: "example",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (insertExample('この問題の解説を書いてください')))
                    }, " \"この問題の解説を書いてください\" "),
                    _createElementVNode("div", {
                      class: "example",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (insertExample('この問題の難易度はどうですか？')))
                    }, " \"この問題の難易度はどうですか？\" ")
                  ]),
                  _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"empty-state__shortcuts\" data-v-938b21f8><div class=\"shortcut-item\" data-v-938b21f8><kbd data-v-938b21f8>⌘⇧L</kbd> Toggle Editor ↔ Chat</div><div class=\"shortcut-item\" data-v-938b21f8><kbd data-v-938b21f8>⌘⇧P</kbd> Toggle Chat ↔ Preview</div><div class=\"shortcut-item\" data-v-938b21f8><kbd data-v-938b21f8>⌘⏎</kbd> Apply Changes</div><div class=\"shortcut-item\" data-v-938b21f8><kbd data-v-938b21f8>Esc</kbd> Back to Editor</div></div>", 1))
                ]))
              : _createCommentVNode("v-if", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (msg) => {
              return (_openBlock(), _createBlock(ChatMessageComponent, {
                key: msg.id,
                message: msg,
                onApply: onApplyChanges,
                onReject: onRejectChanges
              }, null, 8 /* PROPS */, ["message"]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */),
          _createCommentVNode(" Input Area "),
          _createElementVNode("div", _hoisted_8, [
            _createCommentVNode(" System Prompt (collapsible) "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "system-prompt-toggle",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (systemPromptExpanded.value = !systemPromptExpanded.value))
              }, [
                _createElementVNode("span", null, _toDisplayString(systemPromptExpanded.value ? '▼' : '▶') + " ⚙ System Prompt", 1 /* TEXT */),
                (customSystemPrompt.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "custom"))
                  : _createCommentVNode("v-if", true)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((customSystemPrompt).value = $event)),
                  class: "system-prompt-textarea",
                  placeholder: "カスタムシステムプロンプトを入力...\n基本のchat/edit modeルールは常に維持されます。\nここに入力した内容は追加指示として適用されます。\nドキュメントコンテキストは自動的に追加されます。\n⚠️ QSyntaxルールは自動的に維持されます。",
                  rows: "5"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, customSystemPrompt.value]
                ]),
                (customSystemPrompt.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "system-prompt-clear",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (customSystemPrompt.value = ''))
                    }, " Reset to default "))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */), [
                [_vShow, systemPromptExpanded.value]
              ])
            ]),
            _createCommentVNode(" Template selector "),
            (promptForQuestions.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "template-label" }, "Template", -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedPromptId).value = $event)),
                    class: "template-select",
                    disabled: isStreaming.value
                  }, [
                    _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "-- None --", -1 /* CACHED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promptForQuestions.value, (prompt) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: prompt.id,
                        value: prompt.id
                      }, _toDisplayString(prompt.title), 9 /* TEXT, PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_13), [
                    [_vModelSelect, selectedPromptId.value]
                  ]),
                  (selectedPromptId.value && schoolId.value)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: `/admin/schools/${schoolId.value}/prompts/${selectedPromptId.value}/edit`,
                        target: "_blank",
                        rel: "noopener",
                        class: "template-edit-btn",
                        title: "このテンプレートを編集 (新しいタブ)"
                      }, "✏️", 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Mode toggle (Ask / Agent) "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["mode-btn", { active: chatMode.value === 'agent' }]),
                disabled: isStreaming.value,
                title: "エディタを編集します（差分を提案）",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (chatMode.value = 'agent'))
              }, "✏️ Agent", 10 /* CLASS, PROPS */, _hoisted_17),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["mode-btn", { active: chatMode.value === 'ask' }]),
                disabled: isStreaming.value,
                title: "会話のみ（エディタは変更しません）",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (chatMode.value = 'ask'))
              }, "💬 Ask", 10 /* CLASS, PROPS */, _hoisted_18)
            ]),
            _createCommentVNode(" Model selector + Thinking toggle "),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "template-label" }, "Model", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedModel).value = $event)),
                  class: "template-select",
                  disabled: isStreaming.value
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedModels.value, (group) => {
                    return (_openBlock(), _createElementBlock("optgroup", {
                      key: group.provider,
                      label: group.provider
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.models, (model) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: model.id,
                          value: model.id
                        }, _toDisplayString(model.name) + _toDisplayString(model.supports_thinking ? ' 🧠' : ''), 9 /* TEXT, PROPS */, _hoisted_23))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 8 /* PROPS */, _hoisted_22))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_21), [
                  [_vModelSelect, selectedModel.value]
                ])
              ]),
              (selectedModelSupportsThinking.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["thinking-label", { active: thinkingEnabled.value, required: selectedModelRequiresThinking.value }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((thinkingEnabled).value = $event)),
                        disabled: isStreaming.value || selectedModelRequiresThinking.value
                      }, null, 8 /* PROPS */, _hoisted_25), [
                        [_vModelCheckbox, thinkingEnabled.value]
                      ]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", { class: "thinking-icon" }, "🧠", -1 /* CACHED */)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(selectedModelRequiresThinking.value ? 'Think (required)' : 'Think'), 1 /* TEXT */)
                    ], 2 /* CLASS */)
                  ]))
                : _createCommentVNode("v-if", true),
              (schoolId.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: `/admin/schools/${schoolId.value}/exam_editor_models`,
                    target: "_blank",
                    class: "config-models-btn",
                    title: "Configure available models"
                  }, "⚙️", 8 /* PROPS */, _hoisted_27))
                : _createCommentVNode("v-if", true)
            ]),
            _createCommentVNode(" Context indicator (captured via Cmd+Shift+L) "),
            (capturedContext.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, " 📌 Lines " + _toDisplayString(capturedContext.value.selectionStartLine) + "–" + _toDisplayString(capturedContext.value.selectionEndLine), 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "captured-context__clear",
                      onClick: clearCapturedContext,
                      title: "Clear context"
                    }, "✕")
                  ]),
                  _createElementVNode("pre", _hoisted_31, _toDisplayString(truncatedCapturedText.value), 1 /* TEXT */)
                ]))
              : (currentContextLabel.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(currentContextLabel.value), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" Pending images preview "),
            (pendingImages.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingImages.value, (img, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "pending-image"
                    }, [
                      _createElementVNode("img", {
                        src: img.previewDataUrl,
                        alt: img.filename
                      }, null, 8 /* PROPS */, _hoisted_34),
                      (img.uploading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, "Uploading..."))
                        : (img.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(img.error), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                      _createElementVNode("button", {
                        class: "pending-image__remove",
                        onClick: ($event: any) => (removePendingImage(idx)),
                        title: "Remove"
                      }, "✕", 8 /* PROPS */, _hoisted_37)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("button", {
                class: "attach-btn",
                onClick: triggerImageUpload,
                disabled: isStreaming.value,
                title: "Attach image (📎)"
              }, "📎", 8 /* PROPS */, _hoisted_39),
              _createElementVNode("input", {
                ref_key: "imageInput",
                ref: imageInput,
                type: "file",
                accept: "image/*",
                multiple: "",
                style: {"display":"none"},
                onChange: onImageFileSelected
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
              _withDirectives(_createElementVNode("textarea", {
                ref_key: "inputField",
                ref: inputField,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((inputText).value = $event)),
                class: "chat-input",
                placeholder: inputPlaceholder.value,
                onKeydown: onInputKeydown,
                onInput: autoResizeInput,
                onPaste: onPaste,
                disabled: isStreaming.value,
                rows: "1"
              }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_40), [
                [_vModelText, inputText.value]
              ]),
              (isStreaming.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "stop-btn",
                    onClick: stopStreaming,
                    title: "Stop generation"
                  }, " ⏹ "))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "send-btn",
                    onClick: sendMessage,
                    disabled: !canSend.value,
                    title: "Send (Enter)"
                  }, " 📤 ", 8 /* PROPS */, _hoisted_41))
            ])
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, activeTab.value === 'chat']
        ]),
        _createCommentVNode(" Preview Tab (slot for existing PreviewComponent) "),
        _withDirectives(_createElementVNode("div", _hoisted_42, [
          _renderSlot(_ctx.$slots, "preview")
        ], 512 /* NEED_PATCH */), [
          [_vShow, activeTab.value === 'preview']
        ]),
        (threadModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "thread-modal-backdrop",
              onClick: _withModifiers(closeThreadManager, ["self"])
            }, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", { class: "thread-modal__header" }, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "thread-modal__title" }, "Threads", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    class: "thread-modal__close",
                    onClick: closeThreadManager,
                    title: "Close"
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("button", {
                    class: "thread-btn",
                    disabled: isStreaming.value || loadingThreads.value,
                    onClick: createNewThread
                  }, " + New thread ", 8 /* PROPS */, _hoisted_45),
                  _createElementVNode("button", {
                    class: "thread-btn",
                    disabled: isStreaming.value || !selectedThreadId.value || loadingThreadDetail.value,
                    onClick: renameCurrentThread
                  }, " Rename ", 8 /* PROPS */, _hoisted_46)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads.value, (thread) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: thread.id,
                      class: _normalizeClass(["thread-item", {
              'thread-item--active': thread.id === selectedThreadId.value,
              'thread-item--disabled': isStreaming.value || loadingThreadDetail.value
            }]),
                      onClick: ($event: any) => (openThread(thread.id))
                    }, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, _toDisplayString(formatThreadLabel(thread)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_51, _toDisplayString(formatThreadTime(thread)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("button", {
                        class: "thread-item__delete",
                        disabled: isStreaming.value || loadingThreadDetail.value,
                        onClick: _withModifiers(($event: any) => (deleteThread(thread.id)), ["stop"]),
                        title: "Delete thread"
                      }, " 🗑 ", 8 /* PROPS */, _hoisted_52)
                    ], 10 /* CLASS, PROPS */, _hoisted_48))
                  }), 128 /* KEYED_FRAGMENT */)),
                  (threads.value.length === 0 && !loadingThreads.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, " No threads yet. "))
                    : _createCommentVNode("v-if", true),
                  (loadingThreads.value || loadingThreadDetail.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, " Loading... "))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (usageModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "usage-modal-backdrop",
              onClick: _withModifiers(closeUsageModal, ["self"])
            }, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", { class: "usage-modal__header" }, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "usage-modal__title" }, "AI Usage", -1 /* CACHED */)),
                  _createElementVNode("button", {
                    class: "usage-modal__close",
                    onClick: closeUsageModal,
                    title: "Close"
                  }, "✕")
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "usage-model-box__label" }, "Current model", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_58, _toDisplayString(selectedModelName.value), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_59, _toDisplayString(selectedModel.value), 1 /* TEXT */)
                  ]),
                  (loadingUsage.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, "Loading usage..."))
                    : (usageError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(usageError.value), 1 /* TEXT */))
                      : (usageData.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["usage-progress__fill", { 'usage-progress__fill--danger': usageData.value.limitExceeded }]),
                                style: _normalizeStyle({ width: usageProgressWidth.value })
                              }, null, 6 /* CLASS, STYLE */)
                            ]),
                            _createElementVNode("div", _hoisted_63, _toDisplayString(usageData.value.usagePercentage) + "%", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _cache[26] || (_cache[26] = _createElementVNode("div", { class: "usage-item__label" }, "Used tokens", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_66, _toDisplayString(formatNumber(usageData.value.totalTokens)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "usage-item__label" }, "Monthly limit", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_68, _toDisplayString(usageData.value.monthlyLimit ? formatNumber(usageData.value.monthlyLimit) : 'Unlimited'), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "usage-item__label" }, "Remaining", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_70, _toDisplayString(usageData.value.monthlyLimit ? formatNumber(Math.max(usageData.value.monthlyLimit - usageData.value.totalTokens, 0)) : '-'), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _cache[29] || (_cache[29] = _createElementVNode("div", { class: "usage-item__label" }, "Messages", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_72, _toDisplayString(formatNumber(usageData.value.totalMessages)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_73, [
                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "usage-item__label" }, "Input tokens", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_74, _toDisplayString(formatNumber(usageData.value.totalInputTokens)), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "usage-item__label" }, "Output tokens", -1 /* CACHED */)),
                                _createElementVNode("div", _hoisted_76, _toDisplayString(formatNumber(usageData.value.totalOutputTokens)), 1 /* TEXT */)
                              ])
                            ]),
                            (usageData.value.limitExceeded)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Monthly token limit reached. "))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

})